import { render, staticRenderFns } from "./SetupSecondFactor.vue?vue&type=template&id=6ba2e0cf&"
import script from "./SetupSecondFactor.vue?vue&type=script&lang=js&"
export * from "./SetupSecondFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports